import { isDefined } from './helpers';
import { Splide } from '@splidejs/splide';

export function initHeader()
{
    scrollMenu();
    triggerBoutonMenu();
    slideKeywords();
    if (window.matchMedia("(min-width: 900px)").matches) {
        initVideo();
    }
}

function initVideo() {
    const wrapper = document.querySelector(".header-video-wrapper video") || null;
    if (!(wrapper)) return;
    const url = wrapper.dataset.src || null;
    if (!(url)) return;
    let source = document.createElement('source');
    source.setAttribute('src', url);
    source.setAttribute('type', 'video/webm');
    wrapper.appendChild(source);
}

function scrollMenu()
{

    const headerMenu = document.querySelector('.header-menu');
    const headerMenuBackground = document.querySelectorAll('.header-menu-background');
    const ratio_to_show = 10;

    if(!isDefined(headerMenu) || !isDefined(headerMenuBackground)) return;

    changeBackground(headerMenu, ratio_to_show)
    window.addEventListener('scroll', function() {
        changeBackground(headerMenu, ratio_to_show);
    },{ passive: true });
}

function changeBackground(container, ratio) {
    if(!isDefined(container) || !isDefined(ratio) ) return;
    let scrollTop =  window.scrollY;
    if(scrollTop >= ratio)
    {
        container.classList.add('show_background')
    }
    else {
        if(container.classList.contains('show_background'))
        {
            container.classList.remove('show_background')
        }
    }
}

function triggerBoutonMenu()
{
    const buttonMenu = document.querySelector('.header-menu-button');

    if(!isDefined(buttonMenu)) return;

    buttonMenu.addEventListener('click', function() {
        buttonMenu.classList.toggle('is-open');
        document.body.classList.toggle('show_menu');
    },{ passive: true });
}

function slideKeywords()
{
    const splideKeywords = document.querySelector('.header-body-footer');

    if(!isDefined(splideKeywords)) return;

    let slider_keywords = new Splide( splideKeywords, {
        type: "loop",
        speed : "1000",   
        interval : "2000",
        pagination:false,
        autoplay: true,
        waitForTransition: false,
        arrows: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        mediaQuery: 'min',
        breakpoints: {
            1190: {
                destroy : true,
            }
        }
    })

    slider_keywords.mount();
}
